import { CommonModule } from '@angular/common';
import { Component, computed, input, signal, Signal, WritableSignal } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { KuiIconModule, KuiModule } from 'app/key-ui';
import { MediaService } from 'app/services/media/media.service';
import { MediaInfoResponse } from '@key-telematics/fleet-api-client';

@Component({
    selector: 'key-save-video-confirmation',
    imports: [
        CommonModule,
        KuiIconModule,
        KuiModule,
        TranslateModule
    ],
    templateUrl: './save-video-confirmation.component.html',
    styleUrls: ['./save-video-confirmation.component.scss']
})
export class SaveVideoConfirmationComponent {
    videoDetails: Signal<MediaInfoResponse> = this.media.videoToSaveDetails;
    saving: WritableSignal<boolean> = signal(false);
    successMessage: WritableSignal<string> = signal('');
    errorMessage: WritableSignal<string> = signal('');
    displayButtons = input<boolean>(true);

    isVideo = computed(() => this.videoDetails().type === 'video');

    message = computed(() => {
        return this.isVideo() ? 
            this.i18n.instant('VIDEOS.MESSAGES.CONFIRM_SAVE_VIDEO') :
            this.i18n.instant('VIDEOS.MESSAGES.CONFIRM_SAVE_IMAGE')
    });
    
    constructor(
        private i18n: TranslateService,
        private media: MediaService
    ){}

    async confirmSave() {
      this.saving.set(true);
      try {
        await this.media.saveVideo(this.videoDetails().id);
        this.saving.set(false);
        this.successMessage.set(this.i18n.instant('VIDEOS.MESSAGES.SUCCESSFULLY_SAVED'));
      } catch (err) {
          console.error(err);
          this.errorMessage.set(err.message);
      }
    }

    close() {
      this.media.setSaveVideoViewState(false);
    }
}
